import request from './_config'
const path = `auto_ads`

export function getAllConfigAds(tiktokAccountId, params) {
    return request({
        url: `${path}/get/${tiktokAccountId}`,
        method: 'get',
        params: {
            campaign_ids: JSON.stringify(params.campaign_ids),
            advertiser_id: params.advertiser_id
        }
    })
}

export function setConfigAds(tiktokAccountId, data) {
    return request({
        url: `${path}/set/${tiktokAccountId}`,
        method: 'post',
        data: {
            campaign_ids: data.campaign_ids,
            advertiser_id: data.advertiser_id,
            config_default: data.config_default,
            config_list: data.config_list,
            status: data.status
        }
    })
}

export function deleteConfigAds(tiktokAccountId, data) {
    return request({
        url: `${path}/delete/${tiktokAccountId}`,
        method: 'post',
        data: {
            campaign_ids: data.campaign_ids,
            advertiser_id: data.advertiser_id
        }
    })
}

export function getAutomatedRules(tiktokAccountId, params) {
    return request({
        url: `${path}/automated_rule/get_by_filter/${tiktokAccountId}`,
        method: 'get',
        params
    })
}

export function createAutomatedRule(tiktokAccountId, data) {
    return request({
        url: `${path}/automated_rule/create/${tiktokAccountId}`,
        method: 'post',
        data
    })
}

export function updateAutomatedRule(tiktokAccountId, data) {
    return request({
        url: `${path}/automated_rule/update/${tiktokAccountId}`,
        method: 'post',
        data
    })
}

export function updateStatusAutomatedRule(tiktokAccountId, data) {
    return request({
        url: `${path}/automated_rule/update_status/${tiktokAccountId}`,
        method: 'post',
        data: {
            advertiser_id: data.advertiser_id,
            rule_ids: data.rule_ids,
            operate_type: data.operate_type
        }
    })
}
